import React, { Component } from "react";
import * as s from "./FilterChip.module.scss";
import { P } from "src/views/shared/components";
import { Icons } from "src/libs/assets";

export interface FilterChipProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  selected?: boolean;
  small?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  hideIcon?: boolean;
}

export class FilterChip extends Component<FilterChipProps> {
  render() {
    const {
      title,
      selected,
      small,
      disabled,
      hidden,
      hideIcon,
      className,
      onClick
    } = this.props;

    const classes = [s.filterChip];
    const paddingWrapperClasses = [s.paddingWrapper];

    if (small) {
      paddingWrapperClasses.push(s.small);
    }

    if (selected) {
      paddingWrapperClasses.push(s.selected);
    }

    if (hidden) {
      classes.push(s.hidden);
    }

    if (disabled) {
      classes.push(s.disabled);
    }

    if (className) {
      classes.push(className);
    }

    return (
      <div className={classes.join(" ")} onClick={disabled ? undefined : onClick}>
        <div className={paddingWrapperClasses.join(" ")}>
          <P>{title}</P>
          {selected && !hideIcon && (
            <img src={Icons.cancel_normal} className={s.cancelButton} alt="Cancel" />
          )}
        </div>
      </div>
    );
  }
}
